import { t } from "i18next";

var reg = /^\d{6,7}$/;

export const getConsumerNumberValidation = (schema) =>
  schema
    .required(t("Consumer number is required"))
    .test("isPositive", t("Consumer number must be positive"), (value) => {
      return +value > 0;
    })
    .test({
      name: "isValidConsumerNumber",
      test: (value) => reg.test(value),
      message: t("Please enter valid consumer number"),
    });
